import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { NewNewsFormCreate } from '../../../features/user/expert/new-news/NewNewsContainer';

export const CreateNewNews: React.FC = () => {
  const history = useHistory();
  const onSuccess = useCallback(() => {}, [history]);

  return <NewNewsFormCreate onSuccess={onSuccess} />;
};
